import { API } from "../api";

export const investorAuthApi = API.injectEndpoints({
  endpoints: (builder) => ({
    investorSignup: builder.mutation({
      query: (body) => ({
        url: "/onboard/investors/signup",
        method: "POST",
        body,
      }),
      transformResponse: (responseData) => responseData?.data,
    }),
    investorLogin: builder.mutation({
      query: (body) => ({
        url: "/onboard/investors/login",
        method: "POST",
        body: {
          company_id: body.company_id,
          identifier: body.identifier,
          password: body.password,
        },
      }),
      transformResponse: (responseData) => responseData?.data,
    }),
    getInvestorProfile: builder.query({
      query: () => ({
        url: "/investors/profile",
        method: "GET",
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "InvestorProfile", id: "CURRENT" }],
    }),
    updateInvestorProfile: builder.mutation({
      query: (body) => ({
        url: "/investors/profile",
        method: "PATCH",
        body,
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: [{ type: "InvestorProfile", id: "CURRENT" }],
    }),
  }),
});

export const {
  useInvestorSignupMutation,
  useInvestorLoginMutation,
  useGetInvestorProfileQuery,
  useUpdateInvestorProfileMutation,
} = investorAuthApi;
